export default class JK {
  static AppVersion = 'av'
  static AccessToken = 'aw'
  static DeviceToken = 'ax'
  static MobileCtyCode = 'ay'
  static MobileNumber = 'az'
  static DeviceHardwareUniqueID = 'ba'
  static VerifyToken = 'bb'
  static VerifyCode = 'bc'
  static Manufacturer = 'bd'
  static Hardware = 'be'
  static Brand = 'bf'
  static Model = 'bn'
  static HWDevice = 'ag'
  static Release = 'hg'
  static Sdk = 'hh'
  static PLMN = 'hi'
  static DisplayName = 'hj'
  static SendRefID = 'ey'
  static Name = 'ez'
  static LocationX = 'fa'
  static LocationY = 'hk'
  static IsRefreshList = 'hl'
  static RowVersion = 'w'
  static UserIdList = 'fz'
  static QRCode = 'co'
  static ChatAccHdrID = 'z'

  static FromUserID = 'a'
  static ToUserID = 'b'
  static FlowType = 'c'
  static MsgType = 'd'
  static OriginUserID = 'e'
  static Timeout = 'f'
  static TextMsg = 'g'
  static ImgWidth = 'h'
  static ImgHeight = 'i'
  static Duration = 'j'
  static BurnTime = 'k'
  static ChatMsgID = 'l'
  static UserID = 'm'
  static SvrCreateTime = 'n'
  static TNFileSize = 'o'
  static FSFileSize = 'p'
  static CSFileSize = 'q'
  static TNFileToken = 'r'
  static FSFileToken = 's'
  static CSFileToken = 't'
  static VRead = 'u'
  static DelUser = 'v'
  static UserName = 'x'
  static PhoneNumber = 'y'

  static ChatAccType = 'aa'
  static Notice = 'ab'
  static ListOfUser = 'ac'
  static ParentChatAccHdrID = 'ad'
  static PrivateAlias = 'ae'
  static PrivateCode = 'af'
  static PostChatAccHdrID = 'au'

  static Reset = 'af'
  static ChatAccHdrMaxRowVersion = 'ai'
  static ChatAccMeHdrMaxRowVersion = 'aj'
  static ChatAccDtlMaxRowVersion = 'ak'
  static ChatAccHdrRowVersionList = 'al'
  static ChatAccMeHdrRowVersionList = 'am'
  static ChatAccDtlRowVersionList = 'an'
  static BlockChatAccDtlID = 'ao'
  static Block = 'ap'
  static Level = 'aq'
  static ChatInviteCode = 'ar'
  static ChatAccDtlRowVer = 'as'
  static ChatAccHdrIDList = 'at'

  static ForwardFromChatMsgID = 'bg'
  static ChatAccParentHdrID = 'bh'

  static ItemPerPage = 'bj'
  static ActionType = 'bk'
  static LocX = 'bl'
  static LocY = 'bm'

  static DeleteAll = 'bo'
  static OrgRowVerList = 'bp'
  static OrgGrpRowVerList = 'bq'
  static UserRowVerList = 'br'
  static ChatAccHdrRowVerList = 'bs'
  static ChatAccDtlRowVerList = 'bt'
  static ChatAccMeHdrRowVerList = 'bu'
  static FileToken = 'bv'
  static OrgMaxRowVersion = 'bw'
  static InviteMaxDeleteRowVersion = 'bx'
  static OrgGpMaxRowVersion = 'by'
  static OrgRowVersionList = 'bz'

  static OrgGpRowVersionList = 'ca'
  static OrgIdList = 'cb'
  static OrgGpMaxDeleteRowVersion = 'cc'
  static ChatAccMeMaxRowVersion = 'cd'
  static ChatMsgMaxRowVersion = 'ce'
  static ChatAccDtlMaxDeleteRowVersion = 'cf'
  static InviteMaxRowVersion = 'cg'
  static GateMaxRowVersion = 'ch'
  static InvDtlID = 'ci'
  static OrgID = 'cj'
  static DeleteNotifyID = 'ck'
  static ClearAll = 'cl'
  static ContactList = 'cm'
  static PhoneList = 'cn'

  static CodeType = 'cp'
  static Code = 'cq'
  static TimeFrom = 'cr'
  static TimeTo = 'cs'
  static MaxGateHdrID = 'ct'
  static VisitorRefNum = 'cu'
  static Title = 'cv'
  static AccessType = 'cw'
  static InvitorID = 'cx'
  static VisitorID = 'cy'
  static VisitorPhoneNumber = 'cz'

  static VisitorName = 'da'
  static VisitorIC = 'db'
  static VisitorReachTime = 'dc'
  static VisitorTNFileToken = 'dd'
  static VisitorFSFileToken = 'de'
  static VisitorCSFileToken = 'df'
  static CheckInType = 'dg'
  static LocalCheckInTime = 'dh'
  static CheckInGuardID = 'di'
  static CheckOutType = 'dj'
  static LocalCheckOutTime = 'dk'
  static CheckOutGuardID = 'dl'
  static CheckInMemo = 'dm'
  static CheckOutMemo = 'dn'
  static CheckInLocX = 'do'
  static CheckInLocY = 'dp'
  static IsFinish = 'dq'
  static CheckOutLocX = 'dr'
  static CheckOutLocY = 'ds'
  static InvDtlIdList = 'dt'
  static GateHdrID = 'du'
  static SearchVal = 'dv'
  static RefNum = 'dw'
  static ProfileQRCode = 'dx'
  static Memo = 'dy'
  static Keyword = 'dz'

  static TargetLocX = 'ea'
  static TargetLocY = 'eb'
  static CreateLocX = 'ec'
  static CreateLocY = 'ed'
  static ListOfGroup = 'ee'
  static OrgLevel = 'ef'
  static InviteMaxDay = 'eg'
  static InviteMaxDuration = 'eh'
  static InviteAppMaxDay = 'ei'
  static InviteAppMaxDuration = 'ej'
  static RowVersionList = 'ek'
  static GrpID = 'el'
  static GrpLevel = 'em'
  static Address = 'en'
  static Office = 'eo'
  static CarPlateList = 'ep'
  static MinRowVersion = 'eq'
  static InvitorUser = 'er'
  static VisitorUser = 'es'
  static TargetStartDate = 'et'
  static TargetEndDate = 'eu'
  static TargetDate = 'ev'
  static DateType = 'ew'
  static NumVisit = 'ex'

  static SystemOrgStatus = 'fb'
  static ExpireTime = 'fc'
  static SystemPermission = 'fd'
  static MerchantID = 'fe'
  static MerchantName = 'ff'
  static MerchantURL = 'fg'
  static MerchantTNFileToken = 'fh'
  static DeleteTime = 'fi'
  static TotalDtl = 'fj'
  static Index = 'fk'
  static UserGrpDispName = 'fl'
  static CarPlate = 'fm'
  static InvHdrID = 'fn'
  static QRCode1 = 'fo'
  static QRCode2 = 'fp'
  static SendTime = 'fq'
  static TargetStartTime = 'fr'
  static TargetEndTime = 'fs'
  static TargetTime = 'ft'
  static VisitorPhoneNum = 'fu'
  static VisitorFullPhoneNum = 'fv'
  static CheckInTime = 'fw'
  static CheckOutTime = 'fx'
  static RecvTime = 'fy'

  static CountryPhoneCode = 'ga'
  static FaceTNFileToken = 'gb'
  static FaceFSFileToken = 'gc'
  static FaceCSFileToken = 'gd'
  static IsAdmin = 'ge'
  static IsDebug = 'gf'
  static DeviceID = 'gg'
  static LastAccess = 'gh'
  static DeviceOnline = 'gi'
  static SvrTime = 'gj'
  static SvrCheckInTime = 'gk'
  static SvrCheckOutTime = 'gl'
  static Type = 'gm'
  static InvitorName = 'gn'
  static InvitorTNFileToken = 'go'
  static InvitorFSFileToken = 'gp'
  static InvitorCSFileToken = 'gq'
  static ChatAccDtlID = 'gr'
  static ChatDtlLevel = 'gs'
  static ReadTime = 'gt'
  static BlockUserID = 'gu'
  static ReadOnly = 'gv'
  static ChatAccHdrParentID = 'gw'
  static ChatAccHdrName = 'gx'
  static SystemRowStatus = 'gy'
  static InviteCode = 'gz'

  static OAID = 'ha'
  static Token = 'hb'
  static MsgClearMsgID = 'hc'
  static MuteNotify = 'hd'
  static PrivateNotifyAlias = 'he'
  static NotifySound = 'hf'
  static CountryName = 'hm'
  static NativeName = 'hn'
  static CountryCode = 'ho'
  static ISOCode = 'hp'
  static TrunkCode = 'hq'
  static UserInfo = 'hr'
  static ListOfDevice = 'hs'
  static ReturnValue = 'ht'
  static ListOfHdr = 'hu'
  static ListOfDtl = 'hv'
  static ListOfChatMsg = 'hw'
  static ListOfChatMe = 'hx'
  static ModUser = 'hy'
  static ListOfMsg = 'hz'

  static ChatMsg = 'ia'
  static LoadEnd = 'ib'
  static UserRowVersion = 'ic'
  static ChatAccHdrRowVersion = 'id'
  static ChatAccDtlRowVersion = 'ie'
  static AllRead = 'if'
  static DelUserID = 'ig'
  static FileID = 'ih'
  static FileCount = 'ii'
  static ListOfChatHdr = 'ij'
  static ListOfChatDtl = 'ik'
  static ListOfChatMeHdr = 'il'
  static ChatMsgMaxLoad = 'im'
  static ListOfOrgHdr = 'in'
  static ListOfOrgDtl = 'io'
  static ListOfCarPlate = 'ip'
  static ListOfInvite = 'iq'
  static GateInfo = 'ir'
  static ListOfGateHdr = 'is'
  static ListOfGateInvitor = 'it'
  static ListOfGateImg = 'iu'
  static DataLimit = 'iv'
  static DataUsage = 'iw'
  static Header = 'ix'
  static ID = 'iy'
  static End = 'iz'

  static Body = 'ja'
  static Error = 'jb'
  static IsMember = 'jc'
  static UserList = 'jd'
  static CheckInCount = 'je'
  static GateList = 'jf'
  static GateInvitorList = 'jg'
  static VisitorImageList = 'jh'
  static ListOfVerifyVisitor = 'ji'
  static ListOfVisitor = 'jj'
  static ListOfGate = 'jk'
  static ListOfInvitor = 'jl'
  static ListOfOrgInvite = 'jm'
  static Success = 'jn'
  static ListOfOrg = 'jo'
  static ListOfOrgGrpDel = 'jp'
  static OrgGrpID = 'jq'
  static OrgGrpDelRowVersion = 'jr'
  static FilePath = 'js'
  static InvList = 'jt'
  static ContactID = 'ju'
  static VisitorUserID = 'jv'
  static ListOfStopPoint = 'jw'
  static ChatAccHdrToken = 'jx'
  static ChatAccHdrTokenSample = 'jy'
  static ClearCarList = 'jz'

  static ListChatAccHdrID = 'ka'
  static ListActionType = 'kb'
  static Query = 'kc'
  static DeviceType = 'kd'
  static ReportQuery = 'ke'
  static HdrID = 'kf'
  static HdrID2 = 'kg'
  static DeviceActive = 'kh'
  static OldDeviceToken = 'ki'
  static NewDeviceToken = 'kj'
  static MsgLevel = 'kk'
  static PendingID = 'kl'
  static FSFileName = 'km'
  static CSFileName = 'kn'

  static URL = 'ko'
  static MerchantCode = 'kp'
  static LogoFileBig = 'kq'
  static TempleteUrl = 'kr'
  static AboutUs = 'ks'
  static ItemID = 'kt'
  static ItemName = 'ku'
  static ItemDesp = 'kv'
  static TNFileUrl = 'kw'
  static FSFileUrl = 'kx'
  static PrcID = 'ky'
  static PrcName = 'kz'

  static TimeSessionID = 'la'
  static TimeSessionName = 'lb'
  static Active = 'lc'
  static SchdTime = 'ld'
  static SearchTime = 'le'
  static OdrTrnHdrID = 'lf'
  static TotalAmt = 'lg'
  static PaymentAmt = 'lh'
  static PaymentType = 'li'
  static PaymentRefNo = 'lj'
  static OdrTrnDtlID = 'lk'
  static Desp1 = 'll'
  static Desp2 = 'lm'
  static Desp3 = 'ln'
  static Quantity = 'lo'
  static Price = 'lp'
  static PropAddAmt = 'lq'
  static PropMinusAmt = 'lr'
  static PropMinusPercent = 'ls'
  static LineAmt = 'lt'
  static MnItmID = 'lu'
  static StoItmID = 'lv'
  static OrdTrnDtlList = 'lw'
  static EndTime = 'lx'
  static Email = 'ly'
  static OrderNo = 'lz'

  static RefID = 'ma'
  static ItemType = 'mb'
  static CmdType = 'mc'
  static MaxQtyPerDay = 'md'
  static InvitorVerifyTime = 'me'
  static FileName = 'mf'
  static CheckVerifyMemo = 'mg'
  static PaymentTypeId = 'mh'
  static PaymentTypeName = 'mi'
  static PaymentID = 'mj'
  static PayerID = 'mk'
  static TransNum = 'ml'
  static InvoiceNo = 'mm'
  static PaymentState = 'mn'
  static CanDinein = 'mo'
  static CanTakeAway = 'mp'
  static CanDelivery = 'mq'
  static CatName = 'mr'
  static DepositeMinAmt = 'ms'
  static DepositePercent = 'mt'
  static Module = 'mu'
  static LogoFileSmall = 'mv'
  static SchdType = 'mw'
  static CreateTime = 'mx'
  static PaymentStte = 'my'
  static IsRefund = 'mz'

  static ChatAccDtlID_Parent = 'na'
  static ChatAccHdrRowVersion_Parent = 'nb'
  static ChatAccDtlRowVersion_Parent = 'nc'
  static ChatAccMeHdrHideHdr = 'nd'
  static DeleteUserID = 'ne'

  static oahdrid = 'nf'
  static oahdrURL = 'ng'

  // static oahdrImgSmlURL = 'nh'
  // static oahdrImgBigURL = 'nk'
  static oahdrTitle = 'ni'
  static oahdrLastModify = 'nj'
  static ListOfOfficialAccount = 'nl'
  static oahdrURLAccessCode = 'nm'
  static oahdrMemo = 'nn'
  static Language = 'no'
  static EncryptValue = 'np'

  static OAC1R1Name = 'nh'
  static OAC1R1Type = 'nk'
  static OAC1R1Data = 'nq'
  static OAC1R1DataEx = 'nr'
  static OAC1R2Name = 'ns'
  static OAC1R2Type = 'nt'
  static OAC1R2Data = 'nu'
  static OAC1R2DataEx = 'nv'
  static OAC1R3Name = 'nw'
  static OAC1R3Type = 'nx'
  static OAC1R3Data = 'ny'
  static OAC1R3DataEx = 'nz'

  static OrderRefNo = 'oa'
  static mPosUse = 'ob'
  static SoldOut = 'oc'
  static TaxPercent = 'od'
  static SvcPercent = 'oe'
  static IsSvcChg = 'of'
  static TaxAmt = 'og'
  static SvcAmt = 'oh'
  static Rounding = 'oi'
  static RoundAmt = 'oj'
  static CanSitAndOrder = 'ok'
  static Option = 'ol'
  static LastActive = 'om'
  static Password = 'on'
  static PropId = 'oo'
  static ListOfProp = 'op'
  static oahdrErrorURL = 'oq'
  static QtyID = 'or'
  static Pax = 'ot'
  static PrcType = 'ou'
  static PriceRateMsg = 'ov'

  static OAC1R4Name = 'pa'
  static OAC1R4Type = 'pb'
  static OAC1R4Data = 'pc'
  static OAC1R4DataEx = 'pd'

  static OAC1R5Name = 'pe'
  static OAC1R5Type = 'pf'
  static OAC1R5Data = 'pg'
  static OAC1R5DataEx = 'ph'

  static OAC2R1Name = 'pi'
  static OAC2R1Type = 'pj'
  static OAC2R1Data = 'pk'
  static OAC2R1DataEx = 'pl'

  static OAC2R2Name = 'pm'
  static OAC2R2Type = 'pn'
  static OAC2R2Data = 'po'
  static OAC2R2DataEx = 'pp'

  static OAC2R3Name = 'pq'
  static OAC2R3Type = 'pr'
  static OAC2R3Data = 'ps'
  static OAC2R3DataEx = 'pt'

  static OAC2R4Name = 'pu'
  static OAC2R4Type = 'pv'
  static OAC2R4Data = 'pw'
  static OAC2R4DataEx = 'px'

  static OAC2R5Name = 'py'
  static OAC2R5Type = 'pz'
  static OAC2R5Data = 'qa'
  static OAC2R5DataEx = 'qb'

  static OAC3R1Name = 'qc'
  static OAC3R1Type = 'qd'
  static OAC3R1Data = 'qe'
  static OAC3R1DataEx = 'qf'

  static OAC3R2Name = 'qg'
  static OAC3R2Type = 'qh'
  static OAC3R2Data = 'qi'
  static OAC3R2DataEx = 'qj'

  static OAC3R3Name = 'qk'
  static OAC3R3Type = 'ql'
  static OAC3R3Data = 'qm'
  static OAC3R3DataEx = 'qn'

  static OAC3R4Name = 'qo'
  static OAC3R4Type = 'qp'
  static OAC3R4Data = 'qq'
  static OAC3R4DataEx = 'qr'

  static OAC3R5Name = 'qs'
  static OAC3R5Type = 'qt'
  static OAC3R5Data = 'qu'
  static OAC3R5DataEx = 'qv'

  static OAC1Name = 'qw'
  static OAC2Name = 'qx'
  static OAC3Name = 'qy'
  static KtnCode = 'qz'

  static KtnName = 'ra'
  static KtnOpen = 'rb'
  static KtnActive = 'rc'
  static KtnID = 'rd'

  // Public Enum enumEOrder_MchOption As Long
  //       Non = 0
  //       NeedPayment = &H1
  //       AskLoginBeforeCheckout = &H2

  // eprder_option = ol -compare- need payment
  // ol true = need payment false keep info stop -> sucss
  // check out user name pwd ----- using guest login //name & ph cannot edit
}

export class enumEOrder_MchOption {
  static NeedPayment = '0x01'
  static AskLoginBeforeCheckout = '0x02'
  static ScanOrderMustEnterInfo = '0x04'
  static FoodCourtMode = '0x08'
}
